import { render, staticRenderFns } from "./GlobalTips.vue?vue&type=template&id=20b144a6"
import script from "./GlobalTips.vue?vue&type=script&lang=js"
export * from "./GlobalTips.vue?vue&type=script&lang=js"
import style0 from "./GlobalTips.vue?vue&type=style&index=0&id=20b144a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports